"use client";
import Benefits from "@/components/gitbiz/pricing/Benefits";
import HRMSPrice from "./HRMSPrice";
const dark = false;

export default function HrmsPricing({ onePage = false, dark = false }) {

  return (
    <section className="page-section bg-gray-light-1 ">
      <div className="container relative">
        <div className="text-center -mb-60 mb-sm-40">
          {/* <h2 className="section-title-small">Standard Tabs</h2> */}
          {/* <h2 className="section-caption mb-xs-10">Pricing</h2> */}
          <h2 className="section-title-small mb-30 mb-sm-20">
            Simplest Pricing, All the Features You Need
          </h2>
        </div>
        {/* 1st Section */}
        <section
          className={` pt-40 pb-40 ${dark ? "bg-dark-1 light-content" : ""
            }`}
        >
          <Benefits />{" "}
        </section>
        {/* 1st Section */}
        <div className="row pt-40">
          <div className="col-sm-8 offset-sm-2">
            {/* Nav Tabs */}
            <div className="text-center mb-40 mb-xxs-30">
              <ul
                className="nav nav-tabs tpl-tabs animate"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <a
                    href="#item-1"
                    aria-controls="item-1"
                    className="nav-link active"
                    data-bs-toggle="tab"
                    role="tab"
                    aria-selected="true"
                  >
                    <div className="icons-example-box-icon " style={{ fontSize: '40px' }}>
                      {/* <i className="fa-brands fa-amazon " style={{ fontSize: '35px' }}></i> */}
                      <i className="mi-user" style={{ fontSize: '35px' }} />

                    </div>
                    HRMS
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    href="#item-2"
                    aria-controls="item-2"
                    className="nav-link"
                    data-bs-toggle="tab"
                    role="tab"
                    aria-selected="false"
                  >
                    <div className="icons-example-box-icon " style={{ fontSize: '40px' }}>
                      <i className="mi-megaphone" style={{ fontSize: '35px' }}></i>
                    </div>
                    campaigns
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    href="#item-3"
                    aria-controls="item-3"
                    className="nav-link"
                    data-bs-toggle="tab"
                    role="tab"
                    aria-selected="false"
                  >
                    <div className="icons-example-box-icon " style={{ fontSize: '40px' }}>
                      <i className="mi-share" style={{ fontSize: '35px' }}></i>
                    </div>
                    social
                  </a>
                </li>
              </ul>
            </div>
            {/* End Nav Tabs */}
            {/* Tab panes */}
            <div className="tab-content tpl-minimal-tabs-cont">
              <div
                className="tab-pane fade show active"
                id="item-1"
                role="tabpanel"
              >
                {/* <Pricing /> */}
                <HRMSPrice />
              </div>
              <div
                className="tab-pane fade"
                id="item-2"
                role="tabpanel"
              >
                <div className="mb-30 mb-sm-40 text-center">
                  <div className="small text-gray">
                    Choose number of contacts or subscribers
                  </div>
                </div>
                {/* <Pricing /> */}
                <HRMSPrice />

              </div>
              <div
                className="tab-pane fade"
                id="item-3"
                role="tabpanel"
              >
                {/* <Pricing /> */}
                <HRMSPrice />


              </div>
            </div>
            {/* End Tab panes */}
          </div>
        </div>
      </div>
    </section>
  );
}
